export const USER_PROFILE_TAB_LOADING = 'USER_PROFILE_TAB_LOADING';
export const USER_PROFILE_SUBSCRIPTION_DELETED =
  'USER_PROFILE_SUBSCRIPTION_DELETED';
export const USER_PROFILE_DEVICES_UPDATED = 'USER_PROFILE_DEVICES_UPDATED';
export const USER_PROFILE_ON_CALL_STATUS = 'USER_PROFILE_ON_CALL_STATUS';
export const SET_QR_CODE_USE = 'SET_QR_CODE_USE';
export const DISABLE_MOBILE_LOGOUT = 'DISABLE_MOBILE_LOGOUT';
export const DISABLE_WEB_LOGOUT = 'DISABLE_WEB_LOGOUT';
export const DISABLE_AUTH_REVOKE = 'DISABLE_AUTH_REVOKE';

export const setQrCodeUse = value => ({
  type: SET_QR_CODE_USE,
  payload: value,
});

export const setDisableMobileLogout = value => ({
  type: DISABLE_MOBILE_LOGOUT,
  payload: value,
});

export const setDisableWebLogout = value => ({
  type: DISABLE_WEB_LOGOUT,
  payload: value,
});

export const setDisableAuthRevoke = value => ({
  type: DISABLE_AUTH_REVOKE,
  payload: value,
});
